import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './RespuestaPredefinida.types';
import { IRespuestaPredefinida } from './RespuestaPredefinida.lib';
import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
import { UsuarioActual } from '@/views/a-login/login-controlador';

export class RespuestaPredefinida extends IRespuestaPredefinida
{

    public static async create( id: number ): Promise<RespuestaPredefinida>
    {
        let o = new RespuestaPredefinida();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/respuestas_predefinidas';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<RespuestaPredefinida>; Error?: boolean; }>
    {

        let a: Array<RespuestaPredefinida> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/respuestas_predefinidas` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new RespuestaPredefinida( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            delete js.id;
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
            else
            {
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }

        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public Formatear( pregunta: Pregunta ): string
    {
        let e = this.Respuesta;
        e = e.replace( '@nickname', pregunta.Usuario.Nickname );
        e = e.replace( '@nombre', UsuarioActual.Nombre );
        e = e.replace( '@apellido', UsuarioActual.Apellido );
        e = e.replace( '@cuenta', pregunta.Cuenta );
        e = e.replace( '@alias', pregunta.Cuenta );
        return e;
    }
}